import { newTabLink } from 'utils';
import { Originator, Relation } from 'types';

export const handleOriginatorLink = (
  originator: Originator,
  fixed?: boolean
) => () => {
  const id = originator?.id;
  const label = originator?.label;

  const url = fixed
    ? `/rejstriky-detail/${id}`
    : `/rejstriky/all/${label}/0/10/${id}`;

  newTabLink(url);
};

export const getOriginatorFixedLink = (originator: Originator) =>
  window.location.origin + `/badatelna/rejstriky-detail/${originator.id}`;

export function decideRelationLabel(rel: Relation) {
  if (rel.label !== 'související entita') {
    return rel.label;
  }
  return `${
    rel?.originator?.originatorClassLabel ?? 'entita'
  } souvisejíci s jednotkou popisu`;
}
